import React from "react";
import cn from "classnames";
import styles from "./Preview.module.sass";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import { DEFAULT_DECK_AVATAR } from "../../../constants/images";

const Preview = ({ visible, onClose, avatarUrl, file, title }) => {
  const imageSrc = file || avatarUrl || DEFAULT_DECK_AVATAR;
  return (
    <div className={cn(styles.preview, { [styles.visible]: visible })}>
      <button className={styles.close} onClick={onClose}>
        <Icon name="close" size="24" />
      </button>
      <Card
        className={styles.card}
        classCardHead={styles.head}
        title="Deck preview"
        classTitle="title-blue"
      >
        <div className={styles.body}>
          <div className={styles.photo}>
            <img
              src={imageSrc}
              alt="Deck"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = DEFAULT_DECK_AVATAR;
              }}
            />
          </div>
          <div className={styles.line}>
            <div className={styles.title}>
              {title}
            </div>
            {/* <div className={styles.price}>$98</div> */}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Preview;
